import React, { useEffect, useState } from "react";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";

export default function CountdownTimer({
  startAt = 0,
  durationInMinutes = 0,
  onFinish = () => {},
}) {
  const radius = 46;

  const [finishTimestamp, setFinishTimestamp] = useState(
    new Date(startAt).valueOf() + Math.floor(durationInMinutes * 60 * 1000)
  );

  const [timeRemaining, setTimeRemaining] = useState(null);

  const [completedAmt, setCompletedAmt] = useState(0);

  useEffect(() => {
    const cleanup = setInterval(() => {
      const secondsRemaining = Math.floor(getMillisecondsRemaining() / 1000);
      const minutes = Math.floor(secondsRemaining / 60);
      const seconds = Math.floor(secondsRemaining % 60);

      setTimeRemaining(`${formatDigit(minutes)}:${formatDigit(seconds)}`);

      if (secondsRemaining <= 0) {
        onFinish();
      }
    }, 1000);

    return () => {
      clearInterval(cleanup);
    };
  }, []);

  useEffect(() => {
    const cleanup = setInterval(() => {
      setCompletedAmt(
        getMillisecondsRemaining() / (durationInMinutes * 60 * 1000)
      );
    }, 33);

    return () => {
      clearInterval(cleanup);
    };
  }, []);

  function getMillisecondsRemaining() {
    const deltaTime =
      new Date().getTime() - new Date(finishTimestamp).getTime();
    const millisecondsRemaining = Math.floor(deltaTime * -1);

    return millisecondsRemaining;
  }

  function formatDigit(time) {
    if (time < 0) time = 0;
    return `${String(time).length > 1 ? time : "0" + time}`;
  }

  function getCompletedAmtStyling() {
    let ammount = completedAmt;
    if (completedAmt > 1) ammount = 1;
    if (completedAmt < 0) ammount = 0;
    const circumferance = getCircumferance(radius);

    const computed = `${circumferance - circumferance * ammount}px`;

    return computed;
  }

  function getCircumferance(radius) {
    return radius * 2 * Math.PI;
  }

  return (
    <>
      {timeRemaining && (
        <div
          className={`countdown-timer ${isMobileOrTablet() ? "countdown-timer--mobile" : ""}`}
        >
          <div className="completed-ring">
            <svg height="100" width="100">
              <circle
                cx="50"
                cy="50"
                r={radius}
                style={{
                  strokeDashoffset: getCompletedAmtStyling(),
                  strokeDasharray: `${getCircumferance(
                    radius
                  )} ${getCircumferance(radius)}`,
                }}
              />
            </svg>
          </div>
          <span>{timeRemaining}</span>
        </div>
      )}
    </>
  );
}
